import {
  positionStatusContainer,
  positionStatusDefaultClientText,
  positionStatusChartClientText,
  positionStatusEntityText,
  positionStatusArrowIcon,
  positionStatusExternalLinkIcon,
  positionStatusChartContainer,
  positionStatusNotApplicableContainer,
  positionStatusNotApplicableText,
  positionStatusNotApplicableArrow,
  positionStatusNotAttachedContainer,
  positionStatusNotAttachedText,
  positionStatusNotAttachedArrow,
  positionStatusNotAttachedSlashIcon,
  positionStatusNotAttachedExternalLinkIcon,
  positionStatusSimplifiedContainer,
  positionStatusSimplifiedClientText,
  positionStatusSimplifiedInText,
  positionStatusSimplifiedEntityText,
} from "./styles_vanilla.css";
import { PositionStatusConfig, PositionStatusType } from "./types";

export const STATUS_CONFIG: Record<PositionStatusType, PositionStatusConfig> = {
  simplified: {
    containerClass: positionStatusSimplifiedContainer,
    clientTextClass: positionStatusSimplifiedClientText,
    inTextClass: positionStatusSimplifiedInText,
    entityTextClass: positionStatusSimplifiedEntityText,
  },
  "not-attached": {
    containerClass: positionStatusNotAttachedContainer,
    showSlashIcon: true,
    showExternalLink: true,
    clientTextClass: positionStatusNotAttachedText,
    entityTextClass: positionStatusNotAttachedText,
    arrowClass: positionStatusNotAttachedArrow,
    slashIconClass: positionStatusNotAttachedSlashIcon,
    externalLinkIconClass: positionStatusNotAttachedExternalLinkIcon,
  },
  "not-applicable": {
    containerClass: positionStatusNotApplicableContainer,
    clientTextClass: positionStatusNotApplicableText,
    entityTextClass: positionStatusNotApplicableText,
    arrowClass: positionStatusNotApplicableArrow,
  },
  chart: {
    containerClass: positionStatusChartContainer,
    showExternalLink: true,
    clientTextClass: positionStatusChartClientText,
    entityTextClass: positionStatusEntityText,
    arrowClass: positionStatusArrowIcon,
    externalLinkIconClass: positionStatusExternalLinkIcon,
  },
  default: {
    containerClass: positionStatusContainer,
    showExternalLink: true,
    clientTextClass: positionStatusDefaultClientText,
    entityTextClass: positionStatusEntityText,
    arrowClass: positionStatusArrowIcon,
    externalLinkIconClass: positionStatusExternalLinkIcon,
  },
} as const;
